import { api } from './api';
import type { CreateImageUploadUrlInput, CreateImageUploadUrlResult } from '@tabbio/types';

export async function createImageUploadUrl(
  input: CreateImageUploadUrlInput,
): Promise<CreateImageUploadUrlResult> {
  const res = await api.post<CreateImageUploadUrlResult>('/api/media/images/upload-url', input);
  if (res.error) throw new Error(res.error.message);
  if (!res.data) throw new Error('Upload URL request returned no data');
  return res.data;
}
